// The calls of a machine's sequence (contract §3 and §4), always through Api_Functions. One body builder, so the
// field, the arrows and the menu send the SAME request for the same target (INV10); the old route
// `PUT plannerDetail/{direction}/{sortDirection}/{deviceId}` is never used.
import { apiPost, apiPut } from '../../generic/Api_Functions'

const machineUrl = (planId, deviceId) => 'plannerDetails/' + planId + '/device/' + deviceId

/**
 * The body of §3 and §4. `sequenceToken` travels only when there is one (a confirmed preview), as it came.
 * No time zone: Sun uses its own (D-U).
 */
export const buildMoveBody = ({ plannerDetailId, targetPosition, expectedCurrentPosition, sequenceToken = '' }) => {
  const body = { plannerDetailId, targetPosition, expectedCurrentPosition }
  if (typeof sequenceToken === 'string' && sequenceToken !== '') body.sequenceToken = sequenceToken
  return body
}

/** §3: what moving the job would do. Writes nothing. */
export const previewMove = (planId, deviceId, move) => apiPost(machineUrl(planId, deviceId) + '/move/preview', buildMoveBody({ ...move, sequenceToken: '' }))

/** §4: move the job. */
export const moveJob = (planId, deviceId, move) => apiPut(machineUrl(planId, deviceId) + '/move', buildMoveBody(move))
